import Icon from "@mui/icons-material/ForwardToInbox";
import List from "./list";
import Edit from "./edit";
import Create from "./create";

export default {
  list: List,
  edit: Edit,
  create: Create,
  icon: Icon,
  label: "Mailers",
  options: { label: "Mailers" },
  name: "eventMailInfo",
};
